import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import {Response} from '@angular/http';
import {AlertService, JhiLanguageService} from 'ng-jhipster';
import {Formation} from './formation.model';
import {FormationService} from './formation.service';
import {
    ExportService,
    IKeyedCollection,
    JhiAlertComponent,
    KeyedCollection,
    PAGING,
    Principal,
    User
} from '../../shared';
import {ActivatedRoute, Router} from '@angular/router';
import {SelectItem, SortMeta} from 'primeng/components/common/api';
import {CONSTANTS} from '../../cadens.constants';
import {Parametrage, ParametrageService} from '../parametrage';
import {ListeChoixService} from '../../shared/ListeChoix/listeChoix.service';
import {PieceService} from './piece.service';
import {Piece} from './piece.model';
import {NgbActiveModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs';
import {Campagne, CampagneService} from '../campagne';
import {DemandeModifService} from '../blocks/demande-modif/demande-modif.service';
import {DemandeModif} from '../blocks/demande-modif/demande-modif.model';
import {DataTable} from 'primeng/primeng';
import {LocalStorageService} from 'ng2-webstorage';
import {PageScrollInstance, PageScrollService} from 'ng2-page-scroll';
import {DOCUMENT} from '@angular/platform-browser';
import { TranslateService } from 'ng2-translate';
import { JsUtil } from '../../shared/util/jsUtil';
import { log } from 'util';

@Component({
    selector: 'jhi-formation',
    templateUrl: './formation.component.html'
})
/**
 * ROLE_USER   (candidat)     =>pas d'accès au parametrage des formations
 * ROLE_REFERENT  (responsable de formation)  => saisie de ses propres formations
 * ROLE_DELEGATE (enseignant lecteur)   =>pas d'accès au parametrage des formations, affichage des candidatures de ses formations
 * ROLE_GEST   (gestionnaire)     => accès au parametrage de toutes les formations
 * ROLE_ADMIN   (administrateur)   => saisie de toutes les formations
 * ROLE_SYSTEM (administrateur DSI)
 *
 * ROLE_GEST+ ROLE_ADMIN => Gestionnaire Administrateur Foonctionnel (All Access)
 *
 * */
export class FormationComponent implements OnInit, AfterViewInit {
    formations: Formation[];
    selectedFormations: Formation[];
    currentAccount: any;
    public paging: any;
    modalRef: NgbModalRef;
    isReferent = false;
    isAdmin = false;
    isResponsableFormation=false;
    isGestionnaire= false;
    annee: number;
    selectedCampagnesIds = [];
    isLoading: boolean;
    public filters: any;

    // Show / Hide selected columns
    cols: SelectItem[] = [
        {label: 'Id', value: 'id'},
        {label: 'Libellé', value: 'libelle'},
        {label: 'Libellé court', value: 'libelleCourt'},
        {label: 'Campagnes', value: 'campagnes'},
        {label: 'Demande modification', value: 'demandeModifs'},
        {label: 'Pré-avis', value: 'avecPreavis'},
        {label: 'Ayant droit de porter des avis', value: 'respoForma'},
        {label: 'Enseignants lecteurs', value: 'lecteurs'},
        {label: 'Liste complémentaire', value: 'lc'},
        {label: 'Utilisation rang', value: 'rang'},
        {label: 'Affichage rang', value: 'affichageRang'},
        {label: 'Appel sur LC auto', value: 'rangAuto'},
        {label: 'Nombre de places', value: 'nombrePlaces'},
        {label: 'Date suppression', value: 'dateSuppression'}
    ];
    colsAdmin: SelectItem[] = [
        {label: 'Surbooking', value: 'surbooking'},
        {label: 'Nb places surbooking', value: 'nbPlacesSurbooking'},
        {label: 'Nb désistements surbooking', value: 'nbDesistementsSurbooking'}
    ]
    // Actions groupées
    servicesDialog = false;
    piecesDialog = false;
    usersDialog = false;
    campagnesDialog = false;
    paramLCDialog = false;
    servicesList: Parametrage[];
    users: User[];
    campagnesAnneeCourante: Campagne[];
    pieces: Piece[];
    serviceSelected: any;
    actions: SelectItem[] = [];
    selectedAction = [];
    @ViewChild('table') dataTable: DataTable;
    @ViewChild('searchFilter') searchFilter: ElementRef;
    private lastRowIndex: number;
    private lastCampagneRowIndex: number;
    private searchText;
    private subscription: any;
    private backToId: Number;
    private listeComplementaireTriStateValue: any = null;
    private rangTriStateValue: any = null;
    private affichageRangTriStateValue: any = null;
    private rangAutoTriStateValue: any = null;

    static getLocalStorageFilterName() {
        return 'cadensFormationsFilters';
    }

    constructor(private jhiLanguageService: JhiLanguageService,
                private formationService: FormationService,
                private campagneService: CampagneService,
                private listeChoixService: ListeChoixService,
                private alertService: AlertService,
                private pieceService: PieceService,
                private exportService: ExportService,
                private principal: Principal,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private parametrageService: ParametrageService,
                private demandeModifService: DemandeModifService,
                public activeModal: NgbActiveModal,
                private localStorage: LocalStorageService,
                private pageScrollService: PageScrollService,
                private translateService: TranslateService,
                @Inject(DOCUMENT) private document: any
    ) {
        this.paging = PAGING;
        this.jhiLanguageService.setLocations(['formation']);
        this.filters = FormationComponent.defaultFilters();
    }

    private static getObjectPropertyValue(a: Formation, propertyName) {
        let valueProperty: any = null;
        if (Object.prototype.hasOwnProperty.call(a, propertyName)) {
            valueProperty = a[propertyName];
        }
        return valueProperty;
    }

    // Récupération des filtres enregistrés sur le Local Storage, ou alors des filtres par défaut
    private static defaultFilters() {
        return {
            filtreAnneeEnCours: {matchMode: 'equals', value: true},
            supprimee: {matchMode: 'equals', value: false},
            selectedColumns: ['libelle', 'libelleCourt', 'campagnes','nombrePlaces'],
            sortField: null,
            sortOrder: null,
            searchText: null,
            rowPerPage: 20
        };
    }

    loadAll() {
        this.isLoading = true;
        this.formationService.query({
            userId: this.currentAccount.id,
            supprimee: this.filters.supprimee.value
        }).subscribe(
            (res: Response) => {
                this.onSuccess(res.json(), res.headers);
                this.isLoading = false;
                this.onInitFilters();
                this.loadDemandeModif();
                this.envoiEvenementSearchFilterChange();
                if (this.backToId != null) {
                    let backToId = this.backToId;
                    setTimeout(() => {
                        this.scrollToFormation(backToId);
                    }, 1000);
                }
            },
            (res: Response) => {
                this.onError(res);
                this.isLoading = false;
            }
        );
        this.parametrageService.queryVDipAnnee().subscribe(
            (res: Response) => {
                if (res != null && res.json() != null && res.json().length > 0) {
                    let parametre: Parametrage = res.json()[0];
                    this.annee = Number.parseInt(parametre.libelle);
                    this.miseAJourListeCampagne();
                }
            }
            ,
            (res: Response) => this.onError(res)
        );
    }
// Modification du Nombres de places des formations
    savePlaces(formation: Formation) {
        this.formationService.update(formation).subscribe(res => {
            this.isLoading = true;
            // formation.saved = true;
            this.loadAll();
        }, err => {
            this.onError(err);
        });
    }
    scrollToFormation(formationId: Number) {
        if (formationId != null) {
            let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#' + formationId);
            this.pageScrollService.start(pageScrollInstance);
        }
    }

    /****************** FILTRES DU TABLEAU DES CANDIDATURES ******************/
    // Mets à jour le tableau au chargement de la page avec les filtres enregistrés
    onInitFilters() {
        let filtersByKey = {};
        Object.keys(this.filters).forEach(key => {
            if (this.filters[key] != null && this.filters[key].value != null && this.filters[key].value.length > 0) {
                filtersByKey[key] = this.filters[key];
            }
        });
        this.dataTable.sortMode = 'single';
        this.dataTable.sortField = this.filters.sortField;
        this.dataTable.sortOrder = this.filters.sortOrder;
        this.dataTable.filters = filtersByKey;
        this.onChangeFiltreAnneeEnCours(this.filters.filtreAnneeEnCours.value);
    }

    ngOnInit() {

        this.subscription = this.activatedRoute.params.subscribe(params => {
            this.backToId = params['id'];
        });
        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.isReferent = Principal.isOnlyEnseignant(account.authorities);
            this.isAdmin = Principal.isAdmin(account.authorities);
            this.isGestionnaire= Principal.isGestionnaire(account.authorities);
            this.isResponsableFormation = Principal.isResponsableFormation(account.authorities);
            this.getLastFilters();
            this.rajoutColonneSupprimee();
            this.loadAll();
            /**Donne les droits sur boutons actions groupées*/
            if (Principal.isAdmin(account.authorities)) {
                this.actions.push({label: 'Modifier le service', value: 'service'});
            }
            if (Principal.isAdminOrGestionnaire(account.authorities)) {
                this.actions.push({label: 'Ajouter des ayant droit de porter des avis pédagogiques',value: 'referent'});
            }
            if (Principal.isAdminOrGestionnaire(account.authorities) || Principal.isResponsableFormation(account.authorities)) {
                this.actions.push({label: 'Ajouter des enseignants lecteurs', value: 'lecteurs'});
            }
            if (Principal.isAdmin(account.authorities)) {
                this.actions.push({label: 'Rattacher des campagnes', value: 'addcampagnes'});
            }
            if (Principal.isAdmin(account.authorities)) {
                this.actions.push({label: 'Modifier paramètres de la LC', value: 'paramLC'});
            }
        });
    }

    ngAfterViewInit(): void {
        const translateKey = 'cadensApp.formation.colonnes';
        const multiSelectId = 'columnSelection';
        this.translateService.get(translateKey).subscribe(translation => {
            JsUtil.setMultiSelectLabel(multiSelectId, translation);
        });
    }

    goToFormation(formation: Formation) {
        if (this.selectedFormations != null && this.selectedFormations.length > 0) {
            if (this.isReferent) {
                this.router.navigate(['/formation/' + this.selectedFormations[0].id]);
            } else {
                this.router.navigate(['/formation/' + this.selectedFormations.map(f => f.id)]);
            }
        } else {
            this.router.navigate(['/formation/' + formation.id]);
        }
    }

    // Selection d'une action groupée
    onSelectedAction(event) {
        if (this.selectedFormations != null && this.selectedFormations.length > 0) {
            // Sélectionner le service gérant les formations sélectionnées
            if (this.selectedAction.indexOf('service') > -1) {
                this.loadServices();
            } else if (this.selectedAction.indexOf('pieces') > -1) {
                // Rattacher des pj aux formations sélectionnées
                this.piecesDialog = true;
            } else if (this.selectedAction.indexOf('referent') > -1 || this.selectedAction.indexOf('lecteurs') > -1) {
                // Rattacher des référents de formation ou des enseignants lecteurs à des formations
                this.loadUsersListe();
            } else if (this.selectedAction.indexOf('addcampagnes') > -1) {
                // Rattacher les campagnes
                this.loadCampagnesListe();
            } else if (this.selectedAction.indexOf('paramLC') > -1) {
                // Modifier les paramètres de la LC
                this.paramLCDialog = true;
            }
        } else {
            this.selectedAction = [];
        }
    }

    exportCSV() {

        let columnsData: string[] = this.cols.map(col => col.label);
        let colFieldNameDictionary: IKeyedCollection<String> = new KeyedCollection<String>();
        this.cols.forEach(col => {
            colFieldNameDictionary.Add(col.label, col.value);
        });

        let colHeaderDictionary: IKeyedCollection<String> = new KeyedCollection<String>();
        this.cols.forEach(col => {
            colHeaderDictionary.Add(col.value, col.label,);
        });

        this.exportService.toCSVAvecNomOrigineField(
            this.formations, columnsData, colFieldNameDictionary, colHeaderDictionary, 'Formations.csv');
    }

    // Handle the SHIFT key on checkbox click / unclick
    onRowSelect(event, table) {
        let data = table.dataToRender;
        let index = data.findIndex(f => f.id === event.data.id);
        if (event.originalEvent.originalEvent.shiftKey === true && this.lastRowIndex > -1 && this.lastRowIndex !== index) {
            if (this.lastRowIndex < index) {
                for (let i = this.lastRowIndex + 1; i <= index; i++) {
                    if (table.selection.indexOf(data[i].id) < 0) {
                        // this.selectedFormations.push(data[i].id);
                        table.selection.push(data[i]);
                    } else {
                        // this.selectedFormations.splice(this.selectedFormations.indexOf(data[i].id), 1);
                        table.selection.splice(table.selection.indexOf(data[i]), 1);
                    }
                }
            } else if (this.lastRowIndex > index) {
                for (let i = this.lastRowIndex - 1; i >= index; i--) {
                    if (table.selection.indexOf(data[i].id) < 0) {
                        table.selection.push(data[i]);
                    } else {
                        table.selection.splice(table.selection.indexOf(data[i]), 1);
                    }
                }
            }
        } else {
            this.lastRowIndex = index;
        }
    }

    // Popup Services gérant la formation
    loadServices() {
        this.servicesDialog = true;
        this.listeChoixService.query({type: CONSTANTS.SERVICE}).subscribe(
            (res: Response) => {
                this.servicesList = res.json();
            });
    }

    saveService() {
        this.formationService.updateService(this.selectedFormations, this.serviceSelected).subscribe(res => {
            this.servicesDialog = false;
            this.selectedAction = [];
        });
    }

    cancelService() {
        this.servicesDialog = false;
        this.selectedAction = [];
    }

    // Liste des responsables de formations et des enseignants lecteurs
    loadUsersListe() {
        this.usersDialog = true;
        this.users = [];
        /*
        let index = this.selectedAction.indexOf('referent') > -1 ? 'users' : 'lecteurs';
        let users = this.selectedFormations.map(f => f[index]).reduce((a, b) => a.concat(b));
        this.selectedFormations[0][index].forEach(user => {
            let temp = users.filter(u => u.email === user.email);
            if (this.selectedFormations.length != null && this.selectedFormations.length === temp.length) {
                this.users.push(user);
            }
        });
         */
    }

    // Liste des campagnes de l'année courants
    loadCampagnesListe() {
        this.campagnesDialog = true;
        this.campagneService.campagnesAnneeCourante().subscribe(
            (res: Response) => {
                this.campagnesAnneeCourante = res.json();
            },
            (res: Response) => {
                this.campagnesDialog = false;
                this.onError(res);
            }
        );
    }


    selectCampagne(event, formation, index) {
        // In popup Rattacher des campagnes, selections des campagnes!
        if (event.shiftKey && this.lastCampagneRowIndex > -1 && this.lastCampagneRowIndex !== index) {
            // Si l'utilisateur a appuyé sur la touche SHIFT, sélectionner toutes les formations entre les 2 index!
            if (this.lastCampagneRowIndex < index) {
                for (let i = this.lastCampagneRowIndex + 1; i <= index; i++) {
                    this.addSelectedCampagne(this.campagnesAnneeCourante[i], i);
                }
            } else if (this.lastCampagneRowIndex > index) {
                for (let i = this.lastCampagneRowIndex - 1; i >= index; i--) {
                    this.addSelectedCampagne(this.campagnesAnneeCourante[i], i);
                }
            }
        } else {
            this.addSelectedCampagne(formation, index);
            this.lastCampagneRowIndex = index;
        }
    }

    clearCampagneModal() {
        this.activeModal.dismiss('cancel');
        this.campagnesDialog = false;
    }

    saveCampagneModal() {
        this.campagnesDialog = false;
        this.isLoading = true;
        // Rattacher les formations sélectionnées aux campagnes sélectionnées
        let selectedCampagnes: Campagne[] = [];
        this.selectedCampagnesIds.forEach((campagneId) => {
            let campagneadded: Campagne = this.campagnesAnneeCourante.find(campagne => campagne.id == campagneId);
            if (campagneadded != null) {
                selectedCampagnes.push(campagneadded);
                this.selectedFormations.forEach(formation => {
                    if (!campagneadded.formations.find(formationCampagne => formationCampagne == formation.id)) {
                        campagneadded.formations.push(formation.id);
                    }
                });
            }
        });
        if (selectedCampagnes.length > 0) {
            this.campagneService.updateFormations(selectedCampagnes).subscribe(
                res => {
                    this.isLoading = false;
                    this.loadAll();
                },
                (res: Response) => {
                    this.isLoading = false;
                    this.onError(res);
                }
            );
        } else {
            this.isLoading = false;
        }
    }

    attachUsers() {
        let updates = [];

        // Ajout des lecteurs ou des référents sélectionnés (this.users)
        // qui ne sont pas déjà dans formation.lecteurs (si ajout de lecteurs) ou dans formation.users (si ajout de référents)

        this.selectedFormations.forEach(formation => {
            this.users.forEach(user => {
                if (this.selectedAction.indexOf('lecteurs') > -1) {
                    if (formation.lecteurs.find(lecteur => user.id === lecteur.id) === undefined) {
                        formation.lecteurs.push(user);
                    }
                } else if (this.selectedAction.indexOf('referent') > -1) {
                    if (formation.users.find(lecteur => user.id === lecteur.id) === undefined) {
                        formation.users.push(user);
                    }
                }
            });
            updates.push(this.formationService.update(formation));
        });
        Observable.forkJoin(updates).subscribe(results => {
            this.usersDialog = false;
            this.selectedAction = [];
        }, error => {
            this.alertService.error(error);
            this.usersDialog = false;
            this.selectedAction = [];
        });
    }

    cancelUsers() {
        this.usersDialog = false;
        this.selectedAction = [];
    }

    // Popup Pieces jointes sur les formations
    savePieces() {
        if (this.pieces != null && this.pieces.length > 0) {
            let piecesFormations: Piece[] = [];
            this.pieces.forEach(piece => {
                this.selectedFormations.forEach(formation => {
                    let copy: Piece = Object.assign({}, piece);
                    copy.formationId = formation.id;
                    piecesFormations.push(copy);
                });
            });
            this.pieceService.update(piecesFormations).subscribe(res => {
                this.piecesDialog = false;
                this.selectedAction = [];
            });
        }
    }

    cancelPieces() {
        this.piecesDialog = false;
        this.selectedAction = [];
    }

    // Popup modif parametres LC
    saveParamLC() {
        let updates = [];
        this.selectedFormations.forEach(formation => {
            if (this.listeComplementaireTriStateValue != null) {
                formation.lc = this.listeComplementaireTriStateValue;
            }
            if (this.rangTriStateValue != null) {
                formation.rang = this.rangTriStateValue;
            }
            if (this.affichageRangTriStateValue != null) {
                formation.affichageRang = this.affichageRangTriStateValue;
            }
            if (this.rangAutoTriStateValue != null) {
                formation.rangAuto = this.rangAutoTriStateValue;
            }
            updates.push(this.formationService.update(formation));
        });
        Observable.forkJoin(updates).subscribe(results => {
            this.closeParamLC();
        }, error => {
            this.alertService.error(error);
            this.closeParamLC();
        });
    }

    closeParamLC() {
        this.paramLCDialog = false;
        this.selectedAction = [];
        this.listeComplementaireTriStateValue = null;
        this.rangTriStateValue = null;
        this.affichageRangTriStateValue = null;
        this.rangAutoTriStateValue = null;
    }

    // noinspection JSMethodCanBeStatic
    getFilterColor(selecteItems: any): string {
        if (selecteItems != null) {
            if (Array.isArray(selecteItems)) {
                if (selecteItems.length > 0) {
                    return 'orange';
                }
            } else {
                return 'orange';
            }
        }
        return 'black';
    }

    errorEventChange(event: String) {
        this.onErrorMessage(event, null);
    }

    public onErrorMessage(message: any, params: any) {
        JhiAlertComponent.onErrorMessage(this.alertService, message, params);
    }

    public onError(response: Response) {
        JhiAlertComponent.onError(this.alertService, response);
    }

    miseAJourListeCampagne() {
        if (this.formations != null) {
            this.formations.forEach(formation =>
                this.filtreCampagnes(formation.campagnes, this.filters.filtreAnneeEnCours.value, this.annee));
        }
    }

    filtreCampagnes(campagnes: Campagne[], filtreAnnee: boolean, annee: Number) {
        if (campagnes != null) {
            if (filtreAnnee == false || annee == null) {
                campagnes.forEach(campagne => campagne['display'] = true);
            } else {
                campagnes.forEach(campagne => campagne['display'] =
                    campagne.dateOuverture != null && (new Date(campagne.dateOuverture)).getFullYear() == annee);
            }
        }
    }

    // filtre sur année en cours
    onChangeFiltreAnneeEnCours(value) {
        this.filters.filtreAnneeEnCours.value = value;
        this.miseAJourListeCampagne();
    }

    // filtre sur supprimee
    onChangeFiltreSupprimee(value) {
        this.filters.supprimee.value = value;
        this.rajoutColonneSupprimee();
        this.loadAll();
    }
    onNbPlacesSort(event: SortMeta) {
        this.sortObjectProperty(event, 'nombrePlaces', this.formations);
    }
    onDateSuppressionSort(event: SortMeta) {
        this.sortObjectProperty(event, 'dateSuppression', this.formations);
    }

    onLibelleSort(event: SortMeta) {
        this.sortObjectProperty(event, 'libelle', this.formations);
    }

    onPreavisSort(event: any) {
        this.sortObjectProperty(event, 'avecPreavis', this.formations);
    }

    onLcSort(event: any) {
        this.sortObjectProperty(event, 'lc', this.formations);
    }

    onRangSort(event: any) {
        this.sortObjectProperty(event, 'rang', this.formations);
    }

    onAffichageRangSort(event: any) {
        this.sortObjectProperty(event, 'affichageRang', this.formations);
    }

    onRangAutoSort(event: any) {
        this.sortObjectProperty(event, 'rangAuto', this.formations);
    }

    onSurbookingSort(event: any) {
        // Tri sur le nb places car le champ boolean n'est pas initialisé ici
        this.sortObjectProperty(event, 'nbPlacesSurbooking', this.formations);
    }

    onNbPlacesSurbookingSort(event: any) {
        this.sortObjectProperty(event, 'nbPlacesSurbooking', this.formations);
    }

    onNbDesistementsSurbookingSort(event: any) {
        this.sortObjectProperty(event, 'nbDesistementsSurbooking', this.formations);
    }

    sortObjectProperty(event: SortMeta, propertyName, arrayToOrder: any[]) {
        let comparer = function (a: Formation, b: Formation): number {
            let result: number = -1;
            if (a == null && b == null) {
                result = 0;
            } else if (a == null) {
                result = -1;
            } else if (b == null) {
                result = 1;
            } else {
                let aValue = FormationComponent.getObjectPropertyValue(a, propertyName);
                let bValue = FormationComponent.getObjectPropertyValue(b, propertyName);
                if (aValue != null && bValue == null) {
                    result = 1;
                } else if (aValue == null && bValue != null) {
                    result = -1;
                } else if (aValue == null && bValue == null) {
                    result = 0;
                } else if (aValue > bValue) {
                    result = 1;
                } else if (aValue == bValue) {
                    result = 0;
                }
            }
            return result * event.order;
        };
        arrayToOrder.sort(comparer);
    }

    onChangeFilterLc($event, field, match) {
        this.dataTable.filter($event.target.value, field, match);
        // this.dataTable.filter($event.target.value,col.field,col.filterMatchMode)
    }

    // Chargement de toutes les filtres de recherche
    getLastFilters() {
        let lastFilters = FormationComponent.defaultFilters();
        let localFilters = null;
        try {
            localFilters = this.localStorage.retrieve(FormationComponent.getLocalStorageFilterName());
        } catch (e) {
            this.localStorage.clear(FormationComponent.getLocalStorageFilterName());
        }
        try {
            if (localFilters != null) {
                for (let prop in lastFilters) {
                    if (localFilters.hasOwnProperty(prop)) {
                        if (localFilters[prop] != null && localFilters[prop].hasOwnProperty('value')) {
                            lastFilters[prop].value = localFilters[prop]['value'];
                        } else {
                            lastFilters[prop] = localFilters[prop];
                        }
                    }
                }
                if (localFilters.hasOwnProperty('searchText')) {
                    lastFilters['searchText'] = localFilters['searchText'];
                }
                if (localFilters.hasOwnProperty('rowPerPage')) {
                    lastFilters['rowPerPage'] = localFilters['rowPerPage'];
                }
                // si il y a des colonnes dans les filtres mémorisés qui n'existent pas dans la liste actuelle on reset les filtres
                if (lastFilters.selectedColumns.filter(selectedColumn =>
                    this.cols.filter(col => col.value === selectedColumn).length === 0).length > 0) {
                    lastFilters = FormationComponent.defaultFilters();
                }
            }
        } catch (e) {
            let lastFilters = FormationComponent.defaultFilters();
        }
        this.filters = lastFilters;
        if (this.filters.hasOwnProperty('searchText')) {
            this.searchText = this.filters['searchText'];
            this.envoiEvenementSearchFilterChange();
        }
        this.onChangeFiltreAnneeEnCours(lastFilters.filtreAnneeEnCours.value);
        return lastFilters;
    }

// Enregistrer les filtres de recherche dans le Local Storage
    saveFilters() {
        this.filters.sortField = this.dataTable.sortField;
        this.filters.sortOrder = this.dataTable.sortOrder;
        this.filters['searchText'] = this.searchText;
        this.filters['rowPerPage'] = this.dataTable.rows != null ? this.dataTable.rows : 20;
        this.localStorage.clear(FormationComponent.getLocalStorageFilterName());
        this.localStorage.store(FormationComponent.getLocalStorageFilterName(), this.filters);
    }

    // Bouton Reset RAZ ou pas des filtres de recherche
    resetFilters(raz
                     :
                     boolean
    ) {
        this.isLoading = true;
        let previousSupprimee = this.filters.supprimee.value;
        if (raz) {
            this.filters = FormationComponent.defaultFilters();
            if (this.filters.hasOwnProperty('searchText')) {
                this.searchText = this.filters['searchText'];
                this.envoiEvenementSearchFilterChange();
            }
            this.onChangeFiltreAnneeEnCours(this.filters.filtreAnneeEnCours.value);
            this.dataTable.reset();
        } else {
            this.getLastFilters();
        }
        if (previousSupprimee !== this.filters.supprimee.value) {
            this.loadAll();
        } else {
            this.isLoading = false;
        }
    }

    // Enregistrer les filtres de recherche dans le Local Storage
    /*
        saveFilters() {
            let filtersToSave = {} ;
            for (let prop in this.filters) {
                if (this.filters[prop]!=null && this.filters[prop].hasOwnProperty('value')
                   && this.filters[prop].hasOwnProperty('matchMode') ){
                    filtersToSave[prop] = {};
                    filtersToSave[prop]['value']=this.filters[prop].value ;
                    filtersToSave[prop]['matchMode']=this.filters[prop].matchMode ;
                }
            }

            filtersToSave['sortField'] = this.dataTable.sortField;
            filtersToSave['sortOrder'] = this.dataTable.sortOrder;
            filtersToSave['searchText'] = this.filters.searchText;
            this.localStorage.store(this.getLocalStorageFilterName(), filtersToSave);
        }
    */

    private envoiEvenementSearchFilterChange() {
        if (this.searchFilter != null) {
            this.searchFilter.nativeElement.value = this.searchText;
            // si value=null le filtre plante dans dataTable
            if (this.dataTable.value != null) {
                this.searchFilter.nativeElement.dispatchEvent(new Event('keyup'));
            }
        }
    }

    private rajoutColonneSupprimee() {
        if (this.filters.supprimee.value == true && !(this.filters.selectedColumns.indexOf('dateSuppression') > -1)) {
            this.filters.selectedColumns.push('dateSuppression');
        }
    }

    private loadDemandeModif() {
        this.demandeModifService.query({
            entityType: 'formation'
        }).subscribe(rep => {
                let modifs: DemandeModif[] = rep.json();
                if (modifs != null) {
                    modifs.forEach(modif => {
                        let formation = this.formations.find(formation => formation.id === modif.entityId);
                        if (formation != null) {
                            if (formation.demandeModifs == null) {
                                formation.demandeModifs = [];
                            }
                            formation.demandeModifs.push(modif);
                        }
                    });
                }
            },
            (res: Response) => this.onError(res));
    }

    /**
     * Si la formation a deja un ID, l'ajouter à la liste des formations sélectionnées
     * Sinon il faut la créer dans la table formation avant de l'ajouter
     * @param campagne campagne sélectionnée
     * @param index de la formation dans la liste
     */
    private addSelectedCampagne(campagne, index) {
        this.pushToSelectedCampagnes(campagne.id);
    }

    /**
     * Sélectionner / Déselectionner une campagne dans la liste
     * @param id de la campagne
     */
    private pushToSelectedCampagnes(id) {
        if (this.selectedCampagnesIds.indexOf(id) < 0) {
            this.selectedCampagnesIds.push(id);
        } else {
            this.selectedCampagnesIds.splice(this.selectedCampagnesIds.indexOf(id), 1);
        }
    }

    private onSuccess(data, headers) {
        this.formations = data;
        this.miseAJourListeCampagne();
        this.paging.length = this.formations.length;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/formation.component.ts